const scheduledServicesUsersFilterModal = {
  filter: 'FILTROS',
  clear: 'limpar filtros',
  site: 'Sites',
  role: 'Funções',
  cancel: 'CANCELAR',
  ok: 'APLICAR',
};

export default scheduledServicesUsersFilterModal;